<template>
  <div>
    <div v-if="actualPage === pageList.bill">
      <div v-for="(i, index) in this.invoices" :key="index">
        <hr>
        <b-row style="margin-left: 10px;">
          <table class="font-weight-bold" style="font-size:15px; width:100%">
            <tr>
              <td style="width:25%;">
                {{ $t('common.nme')}}
                <span class="font-weight-normal" style="display: block; color: #878787;">{{i.name}}</span>
              </td>
              <td style="width:25%;">
                Montant à payer
                <span class="font-weight-normal" style="display: block; color: #878787;">{{i.amount}} {{i.currency}}</span>
              </td>
              <td style="width:20%;">
                Date du paiement
                <span class="font-weight-normal" style="display: block; color: #878787;">{{i.date}}</span>
              </td>
              <button round
                class="text-center button-action firstButtonMarginTop milkyBlockBlack"
                style="margin-left:30px; width: 80%; height:10%; background-color:#4cafb4; border-color:#4cafb4"
                @click="selectInvoice(i)">
                Procéder au paiement
              </button>
            </tr>
          </table>
        </b-row>
      </div>
    </div>
    <div v-if="actualPage === pageList.typePayment && validTransaction">
      <div>
        <div v-if="details.name">
          <h5 class="font-weight-bolder"><img src='../../../assets/static/images/icons/informations.png' class="formIcon" style="vertical-align: bottom; width: 30px; height: 30px; vertical-align: sub"/> {{this.details.name}}</h5>
          <hr>
          <br>
        </div>
        <div v-if="details.amount">
          <h6 class="font-weight-bold label-title">{{ $t('iframe_payment.work_amnt')}}</h6>
          <span class="font-weight-bold label">{{details.amount}} {{details.currency}}</span>
          <br>
          <br>
        </div>
        <div v-if="details.description">
          <h6 class="font-weight-bold label-title">{{ $t('iframe_payment.work_type')}}</h6>
          <span class="font-weight-bold label">{{details.description}}</span>
          <br>
          <br>
        </div>
        <div v-if="details.client.name">
          <h6 class="font-weight-bold label-title">{{ $t('iframe_payment.addrss')}}</h6>
          <span class="font-weight-bold label">{{details.client.name}}</span>
          <br>
          <div v-if="details.client.address">
            <span class="font-weight-bold label">{{details.client.address}}</span>
            <br>
          </div>
          <div v-if="details.client.zipCode | details.client.city">
            <span class="font-weight-bold label">{{details.client.zipCode}} {{details.client.city}}</span>
            <br>
          </div>
          <br>
        </div>
        <div v-if="details.seller.name">
          <h6 class="font-weight-bold label-title">{{ $t('iframe_payment.worker')}}</h6>
          <span class="font-weight-bold label">{{details.seller.name}}</span>
          <br>
          <div v-if="details.seller.address">
            <span class="font-weight-bold label">{{details.seller.address}}</span>
            <br>
          </div>
          <div v-if="details.seller.zipCode | details.seller.city">
            <span class="font-weight-bold label">{{details.seller.zipCode}} {{details.seller.city}}</span>
          </div>
          <hr>
          <br>
        </div>
      </div>
      <div>
        <h5 class="font-weight-bolder label-title">
          <img src="../../../assets/static/images/icons/money.png" class="formIcon" />
          <span>{{ $t('iframe_payment.pymnt_mean')}} </span>
        </h5>
        <br>
        <b-form-radio-group
          id="radioGroupPayment"
          v-model="selectedPayment"
          :options="optionsPayment"
          name="radioGroupPayment">
        </b-form-radio-group>
        <div v-if="selectedPayment === optionsPayment[0]">
          <br>
          <h5 class="font-weight-bolder label-title">{{ $t('iframe_payment.slct_bank')}}</h5>
          <list-dropdown-image
            :placeholder="$t('iframe_payment.slct_bank')"
            :options="['Arkea', 'Banque Populaire', 'BNP PARIBAS', 'Boursorama Banque', 'Caisse Epargne', 'CIC', 'Crédit Agricole', 'Crédit Mutel', 'Hello Bank', 'La Banque Postale', 'LCL', 'Société Générale', 'Autres...']"
            :image="bankImages"
            @input="changeListType"
            v-model="type">
          </list-dropdown-image>
          <br>
          <list-dropdown
            v-if="regional_banks.selectBanquePop"
            :placeholder="$t('iframe_payment.slct_yr') + ' ' + type"
            :options="regional_banks.banque_populaire"
            @input="changeListSubType"
            v-model="subType">
          </list-dropdown>
        </div>
      </div>
    </div>
    <div v-if="bank_choosed && selectedPayment === optionsPayment[0]">
      <!-- <header-back :canBack="true" :onBack="goBack" :isCross="isCross" style="margin-top:2%;"/> -->
      <br>
      <h6 class="font-weight-bolder label-title">{{ $t('iframe_payment.slct_transfer')}}</h6>
      <br>
      <b-row>
        <b-col>
          <b-form-radio v-model="selectedVirement" name="radiosVirement" value="instant" :disabled="activeVrmtInst">{{ $t('iframe_payment.inst')}}</b-form-radio>
        </b-col>
        <b-col>
          <b-form-radio v-model="selectedVirement" name="radiosVirement" value="classic">{{ $t('iframe_payment.clsc')}}</b-form-radio>
        </b-col>
      </b-row>
      <br>
      <br>
      <div v-if="isDisabled && !isAvailable && !isUnavailable" style="color: red;">
        {{ $t('iframe_payment.inst_unvl')}}
      </div>
      <div v-if="isUnavailable" style="color: red;">
        {{ $t('iframe_payment.inst_none')}}
      </div>
      <div v-if="selectedVirement === 'classic' && viban">
        <hr>
        <h5 class="font-weight-bold label-title">{{ $t('iframe_payment.info_clsc')}} :</h5>
        <span class="font-weight-bold label-title">{{ $t('iframe_payment.iban_bnf')}} : <span style="color: black;">{{getIbanWithSpaces(viban)}}</span></span>
        <br>
        <span class="font-weight-bold label-title">{{ $t('iframe_payment.ref')}} : <span style="color: black;">{{details.ref}}</span></span>
        <br>
        <span class="font-weight-bold label-title">{{ $t('iframe_payment.amnt')}} : <span style="color: black;">{{details.amount}} {{details.currency}}</span></span>
      </div>
    </div>
    <div v-if="selectedPayment === optionsPayment[1]">
      <page-axepta :refNr="details.ref" :transId="details.transId" :amount="details.amount" :currency="details.currency" :orderDesc="details.description" :height="700"></page-axepta>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import HeaderBack from '@/pages/LMSGiframe/components/HeaderBack.vue'
import PageAxepta from '@/pages/axepta/PageAxepta.vue'
import listDropdownImage from '@/components/common/listDropdownImage.vue'
import listDropdown from '@/components/common/listDropdownV2.vue'
import {ibanWithSpaces} from '@/helpers/labels.js'

export default {
  name: 'PaymentLMSG',
  components: {
    'header-back': HeaderBack,
    'list-dropdown-image': listDropdownImage,
    'list-dropdown': listDropdown,
    'page-axepta': PageAxepta
  },
  data () {
    return {
      actualPage: 0,
      choosePayment: false,
      isAvailable: false,
      isDisabled: false,
      isUnavailable: false,
      pageList: {
        bill: 0,
        selectBank: 1,
        typePayment: 2
      },
      optionsPayment: ['Virement Bancaire', 'Carte Bancaire'],
      selectedPayment: 'Virement Bancaire',
      selectedVirement: undefined,
      type: undefined,
      subType: undefined,
      bankImages: ['arkea.png', 'banque_pop.jpg', 'bnp.png', 'boursorama.png', 'caisse_epargne.png', 'cic.jpg', 'ca.png', 'credit_mutuel.jpg', 'hellobank.png', 'banque_postale.png', 'lcl.png', 'soge.png', 'other.png'],
      regional_banks: {
        selectBanquePop: false,
        banque_populaire: ['Banque Populaire Alasace Lorraine Champage', 'Banque populaire Aquitaine Centre Atlantique', 'Banque populaire Auvergne-Rhône-Alpes', 'Banque populaire Bourgogne-Franche-Comté', 'Banque populaire du Nord', 'Banque populaire du Sud', 'Banque populaire Grand Ouest', 'Banque populaire Méditerranée', 'Banque populaire Occitane', 'Banque populaire Rives de Paris', 'Banque populaire Val de France', 'BRED Banque populaire']
      },
      bank_choosed: false,
      details: {
        ref: '',
        transId: '',
        amount: '',
        currency: '',
        name: '',
        description: '',
        username: '',
        client: {
          name: '',
          address: '',
          zipCode: '',
          city: ''
        },
        seller: {
          name: '',
          address: '',
          zipCode: '',
          city: ''
        }
      },
      invoices: [
        {
          name: 'Facture d\'Acompte',
          ref: 'LMSG_AC_30072021',
          amount: '400.00',
          currency: 'EUR',
          date: '30-07-2021'
        },
        {
          name: 'Facture intermédiaire 1',
          ref: 'LMSG_FI1_30082021',
          amount: '200.00',
          currency: 'EUR',
          date: '30-08-2021'
        },
        {
          name: 'Facture intermédiaire 2',
          ref: 'LMSG_FI2_30092021',
          amount: '200.00',
          currency: 'EUR',
          date: '30-09-2021'
        },
        {
          name: 'Facture finale',
          ref: 'LMSG_FF_30102021',
          amount: '0.80',
          currency: 'EUR',
          date: '30-10-2021'
        }
      ],
      validTransaction: true,
      viban: ''
    }
  },
  computed: {
    activeVrmtInst () {
      return this.isAvailable === false || this.isUnavailable === true || this.isDisabled === true
    }
  },
  created () {
    let selectedInvoice = this.$engine.services.suppliers.selectedInvoice
    if (selectedInvoice && Object.keys(selectedInvoice).length > 0) {
      this.details = selectedInvoice
      /* On met la currency par défaut à EUR */
      if (!this.details.currency) {
        this.details.currency = 'EUR'
      }
      this.actualPage = this.pageList.typePayment
      /* Génération d'un identifiant de transaction */
      this.details.transId = 'EndToEndId_' + moment().format('YYYYMMDDhhmmss') + '_' + Math.random().toString(36).substr(2, 6)
      if (!this.validateInvoice(this.details)) {
        this.validTransaction = false
        throw new Error('No ressource')
      }
    }
    this.getVIBAN()
  },
  methods: {
    changeListType () {
      this.bank_choosed = true
      this.regional_banks.selectBanquePop = false

      if (this.type === 'BNP PARIBAS' || this.type === 'Hello Bank' || this.type === 'La Banque Postale' ||
          this.type === 'Crédit Mutuel' || this.type === 'CIC' || this.type === 'Société Générale' ||
          this.type === 'Crédit Agricole' || this.type === 'Caisse Epargne') {
        this.selectedVirement = 'instant'
        this.isAvailable = true
        this.isDisabled = false
        this.isUnavailable = false
      } else if (this.type === 'Boursorama Banque' || this.type === 'Arkea') {
        this.selectedVirement = 'classic'
        this.isDisabled = true
        this.isAvailable = false
        this.isUnavailable = false
      } else if (this.type === 'LCL') {
        this.selectedVirement = 'classic'
        this.isUnavailable = true
        this.isAvailable = false
        this.isDisabled = false
      } else if (this.type === 'Banque Populaire') {
        this.regional_banks.selectBanquePop = true
        this.bank_choosed = false
      }
    },
    changeListSubType () {
      if (this.subType === 'Banque Populaire Alasace Lorraine Champage') {
        this.selectedVirement = 'instant'
        this.isAvailable = true
        this.isDisabled = false
        this.isUnavailable = false
      } else {
        this.selectedVirement = 'classic'
        this.isUnavailable = true
        this.isAvailable = false
        this.isDisabled = false
      }
      this.bank_choosed = true
    },
    getIbanWithSpaces (iban) {
      return ibanWithSpaces(iban)
    },
    getVIBAN () {
      let that = this

      that.$engine.services.suppliers.getMarketplaceClient({
        Identifier: this.details.username
      })
      .then(function (response) {
        that.viban = response.data.Clients[0].Iban
      })
    },
    selectInvoice (invoice) {
      this.actualPage = this.pageList.typePayment
      this.details.amount = invoice.amount.toUpperCase()
      this.details.currency = invoice.currency.toUpperCase()
      this.details.name = invoice.name.toUpperCase()
      this.details.description = ('Rénovation SDB - ' + invoice.name).toUpperCase()
      this.details.client.name = ('Michel Bard').toUpperCase()
      this.details.client.address = ('18 Rue de l\'argent').toUpperCase()
      this.details.client.zipCode = ('92300').toUpperCase()
      this.details.client.city = ('Levallois-Perret').toUpperCase()
      this.details.seller.name = ('Billy Constru').toUpperCase()
      this.details.seller.address = ('25 Rue de l\'argent').toUpperCase()
      this.details.seller.zipCode = ('92300').toUpperCase()
      this.details.seller.city = ('Levallois-Perret').toUpperCase()
      this.details.ref = invoice.ref
    },
    validateInvoice (invoice) {
      return invoice.ref && invoice.transId && invoice.amount && invoice.currency && invoice.username
    }
  }
}
</script>
<style scoped>
.label-title {
  color: #4cafb4;
}
.label {
  font-size: 15px;
  color: #878787;
}

</style>
